module.exports = __webpack_public_path__ + "static/media/FIU_SGA.a6786947.svg";